export enum IntelligenceFormFieldsEnum {
  INSTALL_DATE = "install_date",
  ONBOARDING_DATE = "onboarding_date",
  COUNTRY = "country",
  MEDIA_SOURCE = "media_source",
  DEVICE_MODAL = "device_modal",
  DEVICE_CATEGORY = "device_category",
  FIRST_APP_VERSION = "first_app_version",
  LAST_APP_VERSION = "last_app_version",

  PRODUCT_CODE = "product_code",
  PLATFORM = "platform",
  TIME_RANGE = "time_range",
  FILTER_NAME = "filter_name",
  FILTER_OPERATOR = "filter_operator",
  FILTER_VALUES = "filter_values",
  FILTERS_SELECTED = "filter_selected",
  QUERY_ORDER = "query_order",
  QUERY_LIMIT = "query_limit",
  IS_INIT_FORM_WITH_PARAMS = "is_init_form_with_params",
  IS_CUSTOM_TITLE = "is_custom_title",
  TITLE = "title",
  DESCRIPTION = "description",
  FORMULA_CUSTOM_METRIC = "formula_custom_metric",
  ALIAS_CUSTOM_METRIC = "alias_custom_metric",
}
